import { helpers } from "../../../packages/helpers";
import { authSelectors } from "../../auth";
import { chatActions } from "../../chat";
import { getTypingNotificationEventData } from "../providers";
import type { AppStore } from "../../../store";
import type { TypingNotificationContent } from "../types";

const { selectUserId } = authSelectors;
const { setOpponentLastTypingTime, resetOpponentLastTypingTime } = chatActions;
const { getNowDate } = helpers.date;

let timeoutId: ReturnType<typeof setTimeout>;

export const showTypingNotificationHandler = (
  { getState, dispatch }: AppStore,
  msg: TypingNotificationContent
) => {
  const userId = selectUserId(getState());
  const { userId: eventUserId } = getTypingNotificationEventData(msg);

  // Исправление косяка БЕКА (они шлют оператору его же ивент)
  if (userId === eventUserId) {
    return;
  }

  const date = getNowDate();

  dispatch(setOpponentLastTypingTime(date));

  if (timeoutId) {
    clearTimeout(timeoutId);
  }

  timeoutId = setTimeout(() => {
    dispatch(resetOpponentLastTypingTime());
  }, 5000);
};
